import { useTranslation } from 'react-i18next';
import TableSort from 'components/Table/TableSort';
import { SORT_BY_OPTIONS_EXCLUDE } from 'constants/general';

import type { ITableHeaderProps } from './interfaces/ITableHeader';

import styles from './scss/TableHeader.module.scss';

function TableHeader({
  headCells,
  className,
  onSortChange,
  orderBy,
}: Readonly<ITableHeaderProps>) {
  const { t } = useTranslation();

  return (
    <div className={`${styles.tableHeader} ${className || ''}`}>
      <div className={styles.expandColumn} />
      {headCells.map(({ id, label, withSort }) => (
        <div key={id} className={styles.headerCell}>
          {withSort && id !== SORT_BY_OPTIONS_EXCLUDE.ACTIONS && id !== SORT_BY_OPTIONS_EXCLUDE.SOURCE ? (
            <TableSort
              active={orderBy.includes(id) || orderBy.includes(`-${id}`)}
              onClickSort={() => onSortChange(id)}
            >
              <span>{t(label)}</span>
            </TableSort>
          ) : (<span>{t(label)}</span>)}
        </div>
      ))}
    </div>
  );
}

export default TableHeader;
